<script>
import { mapActions } from 'vuex';
import { useAlert } from 'dashboard/composables';

export default{
  name: "EditColDescModal",
  props: {
    editKey: {
      type: String,
      required: true,
    },
    editObj: {
      type: Object,
      required: true,
    }
  },
  data(){
    return{
      description: '',
      isLoading: false,
    }
  },
  methods: {
    ...mapActions('gsheet', ['editColumnDescription']),
    async handleConfirm(){
      const payload =  {
        knowledgeId: this.$route.params.GSheetKBId,
        columnName: this.editKey, 
        description: this.description
      }
      try{  
        this.isLoading = true;
        await this.editColumnDescription(payload);
        this.$emit('refresh')
        this.$emit('close')
      }catch(err){
        console.error(err);
        useAlert('Error fetching columns:', err)
      }finally{
        this.isLoading = false;
      }
    }
  },
  mounted(){
    if(this.editObj.description){
      this.description = this.editObj.description;
    }
  }
}
</script>

<template>
  <div class="fixed inset-0 flex items-center justify-center bg-slate-800/80 dark:bg-slate-800/80 z-50">
    <div class="bg-white dark:bg-slate-900 rounded-lg p-6 shadow-lg w-96 max-h-[80vh] overflow-y-auto border border-slate-200 dark:border-slate-700">
      <!-- header -->
      <div class="flex items-center mb-4 justify-between">
        <h1 class="text-xl font-bold text-slate-900 dark:text-slate-100">
          Edit Column Description
        </h1>
        <woot-button
          variant="clear"
          color-scheme="alert"
          icon="dismiss"
          @click="$emit('close')"
        />
      </div>

      <form class="space-y-4">

        <!-- Description -->
        <div>
          <label for="description" class="block mb-1 text-slate-700 dark:text-slate-300">Description:</label>
          <textarea
            v-model="description"
            id="description"
            rows="3"
            placeholder="Enter a description..."
            class="reset-base p-2 rounded w-full border bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 placeholder-slate-400 dark:placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-woot-500 dark:focus:ring-woot-400 border-slate-200 dark:border-slate-700"
          />
        </div>
      </form>

      <!-- Action buttons -->
      <div class="flex justify-end gap-4 mt-6">
        <woot-button color-scheme="secondary" @click="$emit('close')">
          Cancel
        </woot-button>
        <woot-button @click="handleConfirm" :is-loading="isLoading">
          Update
        </woot-button>
      </div>
    </div>
  </div>
</template>